module.exports = __webpack_public_path__ + "img/pic4.f1ca475e.png";